import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import JourneyCard from "@/components/JourneyCard";

export default function Journeys() {
    const [params, setParams] = useSearchParams();
    const cat = params.get("cat");
    const [categories, setCategories] = useState([]);
    const [journeys, setJourneys] = useState([]);

    useEffect(() => { api.get("/categories").then(r => setCategories(r.data)); }, []);
    useEffect(() => {
        api.get("/journeys", { params: cat ? { category: cat } : {} }).then(r => setJourneys(r.data));
    }, [cat]);

    return (
        <div className="min-h-screen relative grain">
            <Header />
            <main className="max-w-[1400px] mx-auto px-6 md:px-10 pt-14 pb-24">
                <div className="overline text-[#5C5C5C]">Catálogo completo</div>
                <h1 className="font-display font-light text-5xl md:text-6xl mt-2 tracking-tight">Jornadas</h1>

                <div className="flex flex-wrap gap-2 mt-8">
                    <button data-testid="filter-all"
                            onClick={() => setParams({})}
                            className={`px-4 py-2 rounded-full font-display text-sm border transition ${!cat ? "bg-[#1A1A1A] text-white border-[#1A1A1A]" : "bg-white text-[#1A1A1A] border-black/10 hover:border-black/30"}`}>
                        Todas
                    </button>
                    {categories.map(c => (
                        <button key={c.id}
                                data-testid={`filter-${c.slug}`}
                                onClick={() => setParams({ cat: c.slug })}
                                className={`px-4 py-2 rounded-full font-display text-sm border transition ${cat === c.slug ? "bg-[#1A1A1A] text-white border-[#1A1A1A]" : "bg-white text-[#1A1A1A] border-black/10 hover:border-black/30"}`}>
                            {c.name}
                        </button>
                    ))}
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
                    {journeys.map(j => (
                        <div key={j.id} className="contents">
                            <JourneyCard journey={j} />
                        </div>
                    ))}
                </div>

                {journeys.length === 0 && (
                    <div className="text-center font-body text-[#5C5C5C] py-20">Nenhuma jornada encontrada nesta categoria.</div>
                )}
            </main>
            <Footer />
        </div>
    );
}
